module.exports = __webpack_public_path__ + "media/images/icon-people-cd1063ec6c4cc24fc88611466ccf381b.png";